import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const EditHomeTutorPricing = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const { id } = useParams();

  const [packageName, setPackageName] = useState("");
  const [description, setDescription] = useState("");
  const [mrp, setMrp] = useState("");
  const [sellPrice, setSellPrice] = useState("");
  const [numberOfLeads, setNumberOfLeads] = useState("");
  const [validity, setValidity] = useState("");
  const [icon, setIcon] = useState(null);

  // Fetch existing data
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/package/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const data = response?.data;
        setPackageName(data?.packageName || "");
        setDescription(data?.description || "");
        setMrp(data?.mrp || "");
        setSellPrice(data?.sellPrice || "");
        setNumberOfLeads(data?.numberOfLeads || "");
        setValidity(data?.validity || "");
        setIcon(data?.icon || null);
      })
      .catch((error) => {
        console.error("Error fetching package data:", error);
      });
  }, [id, API_BASE_URL]);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("packageName", packageName);
    formData.append("description", description);
    formData.append("mrp", mrp);
    formData.append("sellPrice", sellPrice);
    formData.append("numberOfLeads", numberOfLeads);
    formData.append("validity", validity);
    if (icon) {
      formData.append("icon", icon);
    }

    axios
      .put(`${API_BASE_URL}/admin/package/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        alert("Home Tutor Price Updated Successfully.");
        navigate("/all-home-tutor-pricing");
      })
      .catch((error) => {
        console.error("Error updating package:", error);
        alert("Error while updating price.");
      });
  };

  const handleCancel = () => {
    navigate("/all-home-tutor-pricing");
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Edit Home Tutor Package</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={() => navigate("/add-home-tutor-pricing")}
            >
              + Add Price
            </button>
            <button
              className="allSubjects"
              onClick={() => navigate("/all-home-tutor-pricing")}
            >
              All Prices
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Edit Price Details</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-group">
              <label className="label">Package Name:</label>
              <input
                type="text"
                placeholder="Enter Package Name"
                value={packageName}
                onChange={(e) => setPackageName(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label className="label">Description:</label>
              <input
                type="text"
                placeholder="Enter Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label className="label">MRP:</label>
              <input
                type="number"
                placeholder="Enter MRP"
                value={mrp}
                onChange={(e) => setMrp(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label className="label">Sell Price:</label>
              <input
                type="number"
                placeholder="Enter Sell Price"
                value={sellPrice}
                onChange={(e) => setSellPrice(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label className="label">Number of Leads:</label>
              <input
                type="number"
                placeholder="Enter Number of Leads"
                value={numberOfLeads}
                onChange={(e) => setNumberOfLeads(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label className="label">Validity (in months):</label>
              <input
                type="number"
                placeholder="Enter Validity"
                value={validity}
                onChange={(e) => setValidity(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label className="label">Icon:</label>
              <input type="file" onChange={(e) => setIcon(e.target.files[0])} />
            </div>

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Update
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditHomeTutorPricing;
